__turbopack_context__.v({
  "container": "PermissionsScreen-module-scss-module__wv1Q6W__container",
  "content": "PermissionsScreen-module-scss-module__wv1Q6W__content",
  "errorMessage": "PermissionsScreen-module-scss-module__wv1Q6W__errorMessage",
  "hero": "PermissionsScreen-module-scss-module__wv1Q6W__hero",
  "heroImage": "PermissionsScreen-module-scss-module__wv1Q6W__heroImage",
  "permission": "PermissionsScreen-module-scss-module__wv1Q6W__permission",
  "permissions": "PermissionsScreen-module-scss-module__wv1Q6W__permissions",
  "subtitle": "PermissionsScreen-module-scss-module__wv1Q6W__subtitle",
  "title": "PermissionsScreen-module-scss-module__wv1Q6W__title",
});
